(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-recommendations"]) return;
  try {
    
var loadCartRecommendations = function() {
  try {
    var section = document.querySelector('.cart-recommendations');
    if (!section || !section.dataset.url) { return; }
    var request = new XMLHttpRequest();
    request.open('GET', section.dataset.url);
    request.onload = function() {
      try {
        if (request.status >= 200 && request.status < 300) {
          var container = document.createElement('div');
          container.innerHTML = request.response;
          var inner = container.querySelector('.cart-recommendations');
          if (inner && inner.innerHTML.trim()) {
            section.innerHTML = inner.innerHTML;
            if (theme.ProductBlockManager) theme.ProductBlockManager.loadImages(section);
            if (theme.initAnimateOnScroll) theme.initAnimateOnScroll();
          }
        }
      } catch(e) { console.warn('Cart recommendations render error:', e); }
    };
    request.onerror = function() { console.warn('Cart recommendations fetch failed'); };
    request.send();
  } catch(e) { console.warn('Cart recommendations error:', e); }
};

document.addEventListener('shopify:section:load', function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].cart-recommendations')) {
    loadCartRecommendations();
  }
});

loadCartRecommendations();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
(function() {
  try {
  var STORAGE_KEY = 'recently-viewed-handles';

  function getHandles() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch(e) { return []; }
  }

  function sizeImage(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
  }

  function buildCard(product) {
    var handle = product.handle;
    var title = product.title || '';
    var url = '/products/' + handle;
    var imgSrc = sizeImage(product.featured_image);
    var price = product.price_min;
    var formattedPrice = '';
    try {
      formattedPrice = (theme.Shopify && theme.money_format)
        ? theme.Shopify.formatMoney(price, theme.money_format)
        : '';
    } catch(e) {}

    var imgHtml = imgSrc
      ? '<div class="product-block__image product-block__image--primary product-block__image--active">' +
          '<img src="' + imgSrc + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;display:block;">' +
        '</div>'
      : '';

    var card = document.createElement('div');
    card.className = 'product-block';
    card.innerHTML =
      '<div class="block-inner">' +
        '<div class="block-inner-inner">' +
          '<div class="image-cont">' +
            '<a class="product-link" href="' + url + '" aria-label="' + title.replace(/"/g, '&quot;') + '">' +
              '<div class="image-label-wrap"><div>' + imgHtml + '</div></div>' +
            '</a>' +
          '</div>' +
          '<div class="product-block__detail">' +
            '<a href="' + url + '" class="product-link">' +
              '<div class="product-block__title">' + title + '</div>' +
              (formattedPrice ? '<div class="price-area"><span class="price price--current">' + formattedPrice + '</span></div>' : '') +
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>';
    return card;
  }

  function loadRecentlyViewed(sectionEl) {
    if (!sectionEl) return;
    var grid = sectionEl.querySelector('.recently-viewed__scroll');
    if (!grid) return;

    var handles = getHandles();

    var productSection = document.querySelector('[data-section-type="main-product"]');
    if (productSection && productSection.dataset.productHandle) {
      var current = productSection.dataset.productHandle;
      handles = handles.filter(function(h) { return h !== current; });
    }

    var limit = parseInt(sectionEl.dataset.limit, 10) || 6;
    handles = handles.slice(0, limit);

    if (!handles.length) {
      sectionEl.style.display = 'none';
      return;
    }

    sectionEl.style.display = '';
    grid.innerHTML = '';

    var cards = new Array(handles.length);
    var loaded = 0;

    handles.forEach(function(handle, index) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', '/products/' + encodeURIComponent(handle) + '.js');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try { cards[index] = buildCard(JSON.parse(xhr.responseText)); } catch(e) {}
        }
        loaded++;
        if (loaded === handles.length) renderCards();
      };
      xhr.onerror = function() {
        loaded++;
        if (loaded === handles.length) renderCards();
      };
      xhr.send();
    });

    function renderCards() {
      cards.forEach(function(card) { if (card) grid.appendChild(card); });
      if (!grid.children.length) { sectionEl.style.display = 'none'; return; }
      if (theme.initAnimateOnScroll) theme.initAnimateOnScroll();
    }
  }

  var section = document.querySelector('.recently-viewed');
  if (section) loadRecentlyViewed(section);

  document.addEventListener('shopify:section:load', function(event) {
    var el = document.querySelector('[data-section-id="' + event.detail.sectionId + '"].recently-viewed');
    if (el) loadRecentlyViewed(el);
  });

  } catch(e) { console.warn('Recently viewed error:', e); }
})();

  } catch(e) { console.error(e); }
})();
})();
